import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../Tooltip";

import css from "./style.scss";

// Renders tooltip for DNC contacts to show : Public DNC or My Dnc info
const DNCTooltip = ({ children, myDnc, publicDnc }) => {
  return (
    <Tooltip
      position="bottom"
      bgColor="#128292"
      width={myDnc && !publicDnc ? 86 : 106}
      xOffset={34}
      yOffset={-10}
      arrowOffset={25}
      content={
        <div className={css.clsDncInfoWrapper}>
            {publicDnc && <p className={css.clsDncText}>Public DNC</p>}
            {myDnc && <p className={css.clsDncText}>My DNC</p>}
        </div>
      }
      title={<></>}
      hideCloseButton
      contentClassName={css.clsDncTooltipContent}
    >
      {children}
    </Tooltip>
  );
};
export default DNCTooltip;

DNCTooltip.propTypes = {
  /** Whether the contact is in My DNC list */
  myDnc: PropTypes.bool,
  /** Whether the contact is in Public DNC list */
  publicDnc: PropTypes.bool,
  /** The element that triggers the tooltip */
  children: PropTypes.node.isRequired,
};
